export default __webpack_public_path__ + "static/memphis-7c6cc627caf0772d445d08ad3c5596cd.png";